module.exports = __webpack_public_path__ + "img/1.e21f7bd0.png";